module.exports = __webpack_public_path__ + "static/media/Gucci-Multicolor-Short-Sleeve-Printed-Bowling-Shirt-for-Men-Lyst.8c13fa22.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/mens/Gucci-Multicolor-Short-Sleeve-Printed-Bowling-Shirt-for-Men-Lyst.png
// module id = 256
// module chunks = 0